export default class ErpDocumentEntity {
    static getEntityData(elem: any) {
        return {
            id: elem.querySelector("#erp_document_id") ? (elem.querySelector("#erp_document_id") as HTMLInputElement).value : null,
            document_type_id: (elem.querySelector("#erp_document_document_type_id option:checked") as HTMLInputElement).value,
            document_type_name: (elem.querySelector("#erp_document_document_type_name") as HTMLInputElement).value,
        }
    }
}